import { TextInput, Textarea, Switch, Stack } from '@mantine/core';
import { useController, type Control } from 'react-hook-form';
import { MediaStateTypeId } from '@lib2/model/media/MediaStateTypeObj';
import { CONTENT_CONSTRAINTS } from '@/lib/constants/appContent';
import type { ListlistFormData } from '../AppContentUtils';

interface ListlistSettingsSectionProps {
  control: Control<ListlistFormData>;
}

export function ListlistSettingsSection({ control }: ListlistSettingsSectionProps) {
  const { field: titleField, fieldState: titleState } = useController({
    control,
    name: 'title',
  });
  const { field: descField, fieldState: descState } = useController({
    control,
    name: 'descShort',
  });
  const { field: stateField } = useController({
    control,
    name: 'mediaStateTypeId',
  });

  return (
    <Stack gap="md">
      <TextInput
        label="Title"
        value={titleField.value}
        onChange={titleField.onChange}
        onBlur={titleField.onBlur}
        error={titleState.error?.message}
        description={`${titleField.value.length}/${CONTENT_CONSTRAINTS.TITLE_MAX}`}
        maxLength={CONTENT_CONSTRAINTS.TITLE_MAX}
        required
      />

      <Textarea
        label="Description"
        value={descField.value}
        onChange={descField.onChange}
        onBlur={descField.onBlur}
        error={descState.error?.message}
        description={`${descField.value.length}/${CONTENT_CONSTRAINTS.DESC_SHORT_MAX}`}
        maxLength={CONTENT_CONSTRAINTS.DESC_SHORT_MAX}
        rows={3}
      />

      <Switch
        label="Active"
        description="Inactive items are hidden from apps"
        checked={stateField.value === MediaStateTypeId.Active}
        onChange={(e) =>
          stateField.onChange(
            e.currentTarget.checked
              ? MediaStateTypeId.Active
              : MediaStateTypeId.Inactive,
          )
        }
      />
    </Stack>
  );
}
